<template>
  <div v-bind:id="id" class="modal" v-bind:class="{active: showModal, narrow: narrow, pages: pages}" v-show="showModal">
    <a href="javascript:void(0)" class="modal-closer" aria-label="この画面の説明を閉じる" v-on:click="closeModal"></a>
    <div class="contents">
      <div class="modal-header">
        <slot name="header"></slot>
      </div>
      <div class="modal-body" v-scroll-lock="showModal">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import ModalView from '../components/modal-view'

  export default {
    name: 'ModalDialogSp',
    extends: ModalView,
    data () {
      return {
        isDialog: true
      }
    }
  }
</script>
